<div *ngIf="!isMobile" class="form-wrapper search-field" #searchForm>
  <form class="search-form" (ngSubmit)="onSearchSubmit($event)" role="search">
    <div class="search-form__body">
      <div class="input-field">
        <input
          [formControl]="searchInputControl"
          #searchInput
          type="search"
          (input)="onInputChange($event)"
          [placeholder]="placeholder"
          [matAutocomplete]="option"
          [matAutocompletePosition]="'below'"
        />
        <div class="actions">
          <button
            class="clear"
            type="button"
            *ngIf="searchQuery !== ''"
            (click)="clearInput()"
          >
            <span>×</span>
          </button>
          <button class="submit" type="submit">
            <span class="catalog-search-btn">
              <svg width="40" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.3501 8.43711C2.3501 4.79893 5.29942 1.84961 8.9376 1.84961C12.5758 1.84961 15.5251 4.79893 15.5251 8.43711C15.5251 12.0753 12.5758 15.0246 8.9376 15.0246C5.29942 15.0246 2.3501 12.0753 2.3501 8.43711ZM8.9376 0.849609C4.74714 0.849609 1.3501 4.24665 1.3501 8.43711C1.3501 12.6276 4.74714 16.0246 8.9376 16.0246C10.8529 16.0246 12.6024 15.315 13.9376 14.1442L17.359 17.5657C17.5543 17.7609 17.8709 17.7609 18.0662 17.5657C18.2614 17.3704 18.2614 17.0538 18.0662 16.8586L14.6447 13.4371C15.8154 12.1019 16.5251 10.3524 16.5251 8.43711C16.5251 4.24665 13.1281 0.849609 8.9376 0.849609Z"></path>
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
    <mat-autocomplete
      #option="matAutocomplete"
      (optionSelected)="onAutocompleteSelect($event.option.value)"
      class="catalog-autocomplete-panel"
    >
    <span *ngIf="filteredOptions | async as optionsArray">
        <mat-optgroup
          *ngFor="let group of optionsArray"
          [label]="group.groupName"
        >
        <mat-option *ngFor="let option of group.cardTitles" [value]="option">
          <div class="option">
            <span [innerHTML]="option.key| highlight: searchQuery"></span>
          </div>
        </mat-option>
      </mat-optgroup>
      <mat-option *ngIf="!optionsArray.length && !!autocompleteNoResultsText">
        <div class="option no-autocomplete-results">
          {{autocompleteNoResultsText}}
        </div>
      </mat-option>
    </span>
    </mat-autocomplete>
  </form>
</div>
<div *ngIf="isMobile" class="form-wrapper search-field" #searchForm>
  <form class="search-form catalog-mobile-search-form" role="search">
      <div class="search-form__body" (click)="openSearchMobilePopup()">
      <div class="input-field">
        <input [value]="searchQuery" [placeholder]="placeholder" readonly />
        <div class="actions">
          <button class="submit" type="submit">
            <span class="catalog-search-btn">
              <svg width="40" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.3501 8.43711C2.3501 4.79893 5.29942 1.84961 8.9376 1.84961C12.5758 1.84961 15.5251 4.79893 15.5251 8.43711C15.5251 12.0753 12.5758 15.0246 8.9376 15.0246C5.29942 15.0246 2.3501 12.0753 2.3501 8.43711ZM8.9376 0.849609C4.74714 0.849609 1.3501 4.24665 1.3501 8.43711C1.3501 12.6276 4.74714 16.0246 8.9376 16.0246C10.8529 16.0246 12.6024 15.315 13.9376 14.1442L17.359 17.5657C17.5543 17.7609 17.8709 17.7609 18.0662 17.5657C18.2614 17.3704 18.2614 17.0538 18.0662 16.8586L14.6447 13.4371C15.8154 12.1019 16.5251 10.3524 16.5251 8.43711C16.5251 4.24665 13.1281 0.849609 8.9376 0.849609Z"></path>
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<div *ngIf="showOpenMobileSearch" class="catalog-mobile-search">
  <div class="catalog-mobile-search__content">
    <span class="close" (click)="closeSearchMobilePopup()">
      <img src="Content/Images/icons/arrow-mob.svg" width="10" height="18">
    </span>
    <div class="form-wrapper search-field">
      <form class="search-form catalog-mobile-search-form" (ngSubmit)="onSearchSubmit($event)" role="search">
        <div class="search-form__body">
          <div class="input-field">
            <input
              [formControl]="searchInputControl"
              #searchInput
              type="search"
              (input)="onInputChange($event)"
              [placeholder]="placeholder"
              [matAutocomplete]="option"
              [matAutocompletePosition]="'below'"
            />
            <div class="actions">
              <button class="clear" type="button" *ngIf="searchQuery !== ''" (click)="clearInput()">
                <span>×</span>
              </button>
              <button class="submit" type="submit">
                <span class="catalog-search-btn">
                  <svg width="40" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.3501 8.43711C2.3501 4.79893 5.29942 1.84961 8.9376 1.84961C12.5758 1.84961 15.5251 4.79893 15.5251 8.43711C15.5251 12.0753 12.5758 15.0246 8.9376 15.0246C5.29942 15.0246 2.3501 12.0753 2.3501 8.43711ZM8.9376 0.849609C4.74714 0.849609 1.3501 4.24665 1.3501 8.43711C1.3501 12.6276 4.74714 16.0246 8.9376 16.0246C10.8529 16.0246 12.6024 15.315 13.9376 14.1442L17.359 17.5657C17.5543 17.7609 17.8709 17.7609 18.0662 17.5657C18.2614 17.3704 18.2614 17.0538 18.0662 16.8586L14.6447 13.4371C15.8154 12.1019 16.5251 10.3524 16.5251 8.43711C16.5251 4.24665 13.1281 0.849609 8.9376 0.849609Z"></path>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
        <mat-autocomplete
          #option="matAutocomplete"
          (optionSelected)="onAutocompleteSelect($event.option.value)"
          class="catalog-autocomplete-panel"
        >
        <span *ngIf="filteredOptions | async as optionsArray">
            <mat-optgroup
              *ngFor="let group of optionsArray"
              [label]="group.groupName"
            >
            <mat-option *ngFor="let option of group.cardTitles" [value]="option">
              <div class="option">
                {{ option.key }}
              </div>
            </mat-option>
          </mat-optgroup>
          <mat-option *ngIf="!optionsArray.length && !!autocompleteNoResultsText">
            <div class="option no-autocomplete-results">
              {{autocompleteNoResultsText}}
            </div>
          </mat-option>
        </span>
        </mat-autocomplete>
      </form>
    </div>
  </div>
</div>